const About = () => {
  return (
    <div>
      <h3> About Us </h3>
    </div>
  );
};
export default About;
